import isIntersecting from "../utils/isIntersecting.util";

interface mapData {
  lat: number;
  lng: number;
  zoom: number;
  styles: string;
  marker: string;
  url: string;
}

export default class Map {
  private mapElement: HTMLElement;
  private map: google.maps.Map | null;
  private marker: any;
  private mapData: mapData;

  constructor(mapElement: HTMLElement) {
    this.mapElement = mapElement;
    this.map = null;
    this.marker = null;
    this.mapData = {
      lat: parseFloat(window.map_global_vars.lat),
      lng: parseFloat(window.map_global_vars.lng),
      zoom: parseInt(window.map_global_vars.zoom),
      styles: JSON.parse(window.map_global_vars.styles),
      marker: window.map_global_vars.marker,
      url: window.map_global_vars.url,
    };

    this.init();
  }

  init = async (): Promise<void> => {
    isIntersecting(this.mapElement, this.initMap);
  };

  initMap = async (): Promise<void> => {
    this.map = new window.google.maps.Map(this.mapElement, {
      zoom: this.mapData.zoom,
      center: {
        lat: this.mapData.lat,
        lng: this.mapData.lng,
      },
      styles: this.mapData.styles,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      rotateControl: false,
      rotateControlOptions: false,
      scaleControl: false,
      fullscreenControl: false,
    });

    this.marker = new (<any>window).google.maps.Marker({
      position: {
        lat: this.mapData.lat,
        lng: this.mapData.lng,
      },
      icon: this.mapData.marker,
      map: this.map,
    });

    window.google.maps.event.addListener(this.marker, "click", () => {
      window.open(this.mapData.url, "_blank");
    });
  };
}
